import { ApiPath } from "enums";
import { Get } from "utils";

export const getBrands = async (query) => {
  const res = await Get(`${ApiPath.PriceCapture}brand`, query);
  return res.data;
};
